export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-6 reveal">
          <p className="overline">Who we are</p>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A3626] leading-[1.05] tracking-tight">
            A quiet giant<br />in agri-commodity trade.
          </h2>
          <p className="mt-8 text-[#4B5563] text-lg leading-relaxed max-w-xl">
            For nearly two decades, we have connected farm cooperatives, processors and
            millers across India with importers, distributors and food manufacturers
            worldwide. Our work is unglamorous by design — patient sourcing, rigorous
            quality control, and shipments that arrive exactly as promised.
          </p>
          <p className="mt-4 text-[#4B5563] text-lg leading-relaxed max-w-xl">
            We hold a single measure of success: repeat orders from every buyer we win.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
            <div className="border-t border-[#1A3626]/20 pt-4">
              <div className="font-serif-display text-[#1A3626] text-3xl">99.4%</div>
              <div className="text-xs tracking-widest uppercase text-[#4B5563] mt-1">On-time dispatch</div>
            </div>
            <div className="border-t border-[#1A3626]/20 pt-4">
              <div className="font-serif-display text-[#1A3626] text-3xl">450+</div>
              <div className="text-xs tracking-widest uppercase text-[#4B5563] mt-1">Farmer partners</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 relative reveal">
          <img
            src="https://images.pexels.com/photos/34182412/pexels-photo-34182412.jpeg"
            alt="Modern agriculture with drones over fields"
            className="w-full h-[560px] object-cover"
          />
          <div className="absolute -bottom-8 -left-4 md:-left-10 bg-white p-8 shadow-lg border border-[#1A3626]/10 max-w-xs">
            <div className="overline text-[#C5A059]">Since 2008</div>
            <div className="mt-2 font-serif-display text-3xl text-[#1A3626] leading-tight">
              17 years of heritage
            </div>
            <div className="mt-3 text-sm text-[#4B5563] leading-relaxed">
              Family-owned, professionally run — moving harvest from origin to buyer with
              zero compromise.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
